const css = `._bar_178l4_1 {
  background-color: var(--border-color);
  height: 4px;
  display: flex;
  width: 100%;
}
._barFill_178l4_7 {
  height: 4px;
}`;
document.head
    .appendChild(document.createElement("style"))
    .appendChild(document.createTextNode(css));
export {css};
export default {
  "bar": "_bar_178l4_1",
  "barFill": "_barFill_178l4_7"
};